import { render, staticRenderFns } from "./ExercisesNextPage.vue?vue&type=template&id=0bb18329&scoped=true&"
import script from "./ExercisesNextPage.vue?vue&type=script&lang=js&"
export * from "./ExercisesNextPage.vue?vue&type=script&lang=js&"
import style0 from "./ExercisesNextPage.vue?vue&type=style&index=0&id=0bb18329&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb18329",
  null
  
)

export default component.exports